<template>
  <div class="table-responsive" :class="{'ps':!isMobile,'ps--active-x':!isMobile,'ps--active-y':!isMobile}">
    <table class="table tablesorter">
      <colgroup>
        <col style="width: 100px;">
        <col style="width: 300px;">
        <col style="width: 300px;">
        <col style="width: 300px;">
        <col style="width: 100px;">
        <col style="width: 100px;">
        <col style="width: 100px;">
      </colgroup>
      <thead>
        <tr>
          <th>
            <div class="relative">
              <span><b>Status</b></span>
            </div>
          </th>
        <th>
          <div class="relative">
            <span><b>Full name</b></span>
          </div>
        </th>
        <th>
          <div class="relative">
            <span class="text-center"><b>Role</b></span>
          </div>
        </th>
        <th>
          <div class="relative">
            <span class="text-center"><b>Phone number</b></span>
          </div>
        </th>
        <th>
          <div class="relative">
            <span class="text-center"><b>Total days</b></span>
          </div>
        </th>
        <th>
          <div class="relative">
            <span class="text-center"><b>Total hours</b></span>
          </div>
        </th>
        <th>
          <div class="relative">
            <span class="text-center"><b>Total payroll</b></span>
          </div>
        </th>
        </tr>
      </thead>
      <tbody>
      <tr v-for="(values, fullName) in data" :key="fullName" >
        <td>
          <div class="relative" :data-tooltip="values.info">
            <base-button v-if="values.is_working  && values.project_id === projectId" size="sm" simple type="success">{{values.status}}</base-button>
            <base-button v-if="!values.is_working && values.project_id === projectId" size="sm" simple type="danger"> {{values.status}}</base-button>
          </div>
        </td>
        <td>
          <div class="relative">
            <span>{{fullName.split('_').join(' ')}}</span>
          </div>
        </td>
        <td>
          <div class="relative">
            <span>{{values.role}}</span>
          </div>
        </td>
        <td>
          <div class="relative">
            <span>{{phoneNumberFormat(values.phone)}}</span>
          </div>
        </td>
        <td>
          <div class="relative">
            <span style="font-size: 20px;">{{values.days}}</span>
          </div>
        </td>
        <td>
          <div class="relative">
            <span style="font-size: 20px;">{{values.hours}}</span>
          </div>
        </td>
        <td>
          <div class="relative">
            <span style="font-size: 20px;">{{formatter.format(values.money)}}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td></td>
        <td class="text-right" colspan="4">
          <span style="font-size: 20px;" class="text-warning">TOTAL:</span>
        </td>
        <td></td>
        <td>
          <span style="font-size: 20px;" class="text-warning">{{formatter.format(totalCount)}}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import {isMobile, formatter} from "../../plugins/axios";
  export default {
    props: ['data','projectId'],
    name: "employees-report-table",
    data(){
      return{
        isMobile: isMobile,
        formatter: formatter,
        total: 0,
      }
    },
    methods: {
      phoneNumberFormat(phone){

        if (phone.length === 10){
          try{
            const check = parseInt(phone);
            phone = phone.replace(/(\d{3})(\d{3})(\d{4})/, "+1 ($1)-$2-$3");
            return phone;
          }
          catch (e) {
            return phone;
          }
        }
        else return phone;
      },

    },
    computed:{
      totalCount(){
        let total = 0;
        for (let employee in this.data){
          total += this.data[employee].money;
        }
        return total;
      },
    }
  }
</script>

<style scoped>
  [data-tooltip]:before {
    /* needed - do not touch */
    content: attr(data-tooltip);
    position: absolute;
    opacity: 0;

    /* customizable */
    transition: all 0.15s ease;
    padding: 10px;
    color: #333;
    border-radius: 10px;
  }

  [data-tooltip]:hover:before {
    /* needed - do not touch */
    opacity: 1;

    /* customizable */
    background: #fd5d93;
    margin-top: -50px;
    margin-left: 20px;
    color: white;
  }

  [data-tooltip]:not([data-tooltip-persistent]):before {
    pointer-events: none;
  }
</style>
